<template>
  <div class="modal fade" :class="{ 'show d-block': visible }" ref="mdlEnviarPlantilla" data-bs-backdrop="static"
    data-bs-keyboard="false" tabindex="-1" role="dialog"
    :style="visible ? 'display: block; background: rgba(0, 0, 0, 0.55); z-index: 1060;' : ''" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content shadow border-0">
        <!-- Modal Header -->
        <div class="modal-header bg-success text-white py-3">
          <div class="d-flex align-items-center">
            <i class="mdi mdi-send-check-outline font-size-22 me-2"></i>
            <div>
              <h5 class="modal-title text-white mb-0 font-size-16">
                Iniciar conversación / Enviar plantilla
              </h5>
              <small class="text-white-50">
                Personaliza las variables de la plantilla antes de enviarla
              </small>
            </div>
          </div>
          <button type="button" class="btn-close btn-close-white" @click="cerrar" aria-label="Cerrar"
            :disabled="enviando"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body p-4">
          <!-- Datos del contacto receptor -->
          <div class="card border bg-light mb-3 p-3">
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
              <div class="d-flex align-items-center">
                <div class="avatar-xs me-2">
                  <span class="avatar-title rounded-circle bg-success-subtle text-success font-size-14">
                    <i class="mdi mdi-whatsapp"></i>
                  </span>
                </div>
                <div>
                  <div class="fw-bold font-size-14 text-dark">{{ nombreReceptor }}</div>
                  <small class="text-muted font-size-12">
                    {{ (chat?.prefijo ? chat.prefijo + ' ' : '') + (chat?.numero || '') }}
                    <span v-if="esGenerico" class="badge bg-secondary-subtle text-secondary ms-1">Cliente Varios</span>
                  </small>
                </div>
              </div>
              <div>
                <span class="badge bg-success font-size-11">
                  Plantilla: {{ plantilla?.nombre_meta || 'inicio_conversacion' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Vista previa y edición de variables -->
          <div class="row g-3">
            <!-- Columna izquierda: formulario de variables detectadas en la plantilla -->
            <div class="col-lg-6">
              <h6 class="font-size-13 fw-semibold text-secondary mb-2 d-flex align-items-center">
                <i class="mdi mdi-variable me-1 text-primary"></i>
                Valores de las variables
              </h6>
              <p class="text-muted font-size-11 mb-3">
                Edita los valores calculados automáticamente según los datos del contacto o empresa:
              </p>

              <div v-if="variablesDetectadas.length === 0" class="alert alert-info py-2 px-3 font-size-12">
                Esta plantilla no contiene variables dinámicas para personalizar.
              </div>

              <div v-else class="wa-variables-form-list" style="max-height: 280px; overflow-y: auto; padding-right: 4px;">
                <div v-for="tag in variablesDetectadas" :key="tag" class="mb-3">
                  <label class="form-label font-size-12 fw-semibold mb-1 text-dark">
                    <code>{{ tag }}</code>
                    <span class="text-muted fw-normal font-size-11 ms-1">({{ obtenerDescripcionVariable(tag) }})</span>
                  </label>
                  <input type="text" class="form-control form-control-sm" v-model="valoresVariables[tag]"
                    :placeholder="`Valor para ${tag}`" :disabled="enviando" />
                </div>
              </div>
            </div>

            <!-- Columna derecha: Previsualización de la plantilla renderizada estilo WhatsApp -->
            <div class="col-lg-6">
              <h6 class="font-size-13 fw-semibold text-secondary mb-2 d-flex align-items-center">
                <i class="mdi mdi-eye-outline me-1 text-success"></i>
                Vista previa del mensaje
              </h6>

              <div class="wa-template-preview-box p-3 rounded border">
                <!-- Encabezado si existe -->
                <div v-if="encabezadoRenderizado" class="fw-bold font-size-13 text-dark mb-2">
                  {{ encabezadoRenderizado }}
                </div>

                <!-- Cuerpo renderizado -->
                <div class="font-size-13 text-dark mb-2" style="white-space: pre-wrap; line-height: 1.45;">
                  {{ cuerpoRenderizado }}
                </div>

                <!-- Pie de mensaje -->
                <div v-if="plantilla?.pie" class="text-muted font-size-11">
                  {{ plantilla.pie }}
                </div>

                <!-- Hora y palomita simulada -->
                <div class="text-end text-muted font-size-10 mt-2">
                  <span>{{ horaActual }}</span>
                  <i class="mdi mdi-check-all text-muted ms-1 font-size-12"></i>
                </div>
              </div>

              <div class="mt-2 text-muted font-size-11">
                <i class="mdi mdi-information-outline me-1"></i>
                Al enviar la plantilla se abrirá la ventana de conversación oficial con el cliente.
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer bg-light py-2">
          <button type="button" class="btn btn-secondary font-size-13" @click="cerrar" :disabled="enviando">
            <i class="mdi mdi-close me-1"></i>
            Cancelar
          </button>
          <button type="button" class="btn btn-success font-size-13 d-inline-flex align-items-center"
            @click="enviar" :disabled="enviando || cargandoPlantilla">
            <span v-if="enviando" class="spinner-border spinner-border-sm me-2" role="status"></span>
            <i v-else class="mdi mdi-send me-1"></i>
            <span>{{ enviando ? 'Enviando plantilla...' : 'Enviar plantilla' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "bootstrap/js/dist/modal";
import SistemaSrv from "@/services/SistemaSrv.js";
import WhatsappSrv from "@/services/WhatsappSrv.js";
import { PLANTILLAS_PREDETERMINADAS, GRUPOS_VARIABLES } from "@/views/sistema/ajustesSistema/whatsappBusiness/whatsappConstants.js";
import { esClienteGenerico, nombreContacto } from "./whatsappHelpers.js";

export default {
  name: "MdlEnviarPlantillaInicioWhatsapp",
  emits: ["plantilla-enviada"],
  data() {
    return {
      visible: false,
      modalInstancia: null,
      chat: null,
      plantilla: null,
      valoresVariables: {},
      enviando: false,
      cargandoPlantilla: false,
      horaActual: ""
    };
  },
  computed: {
    nombreReceptor() {
      if (!this.chat) return "Contacto";
      return nombreContacto(this.chat);
    },
    esGenerico() {
      return esClienteGenerico(this.chat);
    },
    variablesDetectadas() {
      const texto = `${this.plantilla?.encabezado || ""} ${this.plantilla?.cuerpo || ""}`;
      const matches = texto.match(/\{\{([^}]+)\}\}/g) || [];
      return [...new Set(matches)];
    },
    cuerpoRenderizado() {
      let texto = this.plantilla?.cuerpo || "";
      Object.keys(this.valoresVariables).forEach((tag) => {
        const val = this.valoresVariables[tag] !== undefined && this.valoresVariables[tag] !== null
          ? String(this.valoresVariables[tag])
          : "-";
        texto = texto.split(tag).join(val);
      });
      return texto;
    },
    encabezadoRenderizado() {
      let texto = this.plantilla?.encabezado || "";
      if (!texto) return "";
      Object.keys(this.valoresVariables).forEach((tag) => {
        const val = this.valoresVariables[tag] !== undefined && this.valoresVariables[tag] !== null
          ? String(this.valoresVariables[tag])
          : "-";
        texto = texto.split(tag).join(val);
      });
      return texto;
    }
  },
  mounted() {
    if (this.$refs.mdlEnviarPlantilla) {
      try {
        this.modalInstancia = new Modal(this.$refs.mdlEnviarPlantilla);
      } catch (e) { }
    }
    this.actualizarHora();
  },
  methods: {
    actualizarHora() {
      const d = new Date();
      this.horaActual = `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    },

    abrir(chat) {
      this.mostrar(chat);
    },

    mostrar(chat) {
      this.chat = chat || null;
      this.enviando = false;
      this.actualizarHora();
      this.cargarPlantillaInicio(chat);
      this.visible = true;

      if (!this.modalInstancia && this.$refs.mdlEnviarPlantilla) {
        try {
          this.modalInstancia = new Modal(this.$refs.mdlEnviarPlantilla);
        } catch (e) { }
      }
      if (this.modalInstancia) {
        try {
          this.modalInstancia.show();
        } catch (e) { }
      }
    },

    cerrar() {
      this.visible = false;
      if (this.modalInstancia) {
        try {
          this.modalInstancia.hide();
        } catch (e) { }
      }
    },

    cargarPlantillaInicio(chat) {
      this.cargandoPlantilla = true;

      // 1. Obtener base predeterminada
      const tplBase = PLANTILLAS_PREDETERMINADAS.find((p) => p.id === "inicio_conversacion") || {
        id: "inicio_conversacion",
        titulo: "Inicio de Conversación",
        nombre_meta: "inicio_conversacion",
        tipo_encabezado: "NONE",
        encabezado: "",
        cuerpo: "Hola {{nombre_completo}}, nos comunicamos de {{nombre_empresa}} para dar seguimiento a su cuenta y brindarle asistencia. ¿En qué podemos ayudarle el día de hoy?",
        pie: ""
      };

      // 2. Intentar leer de localStorage o API
      let tplGuardada = null;
      try {
        const raw = localStorage.getItem("argusblack.ajustes_whatsapp_plantilla_inicio_conversacion");
        if (raw) {
          tplGuardada = JSON.parse(raw);
        }
      } catch (e) { }

      this.plantilla = { ...tplBase, ...(tplGuardada || {}) };

      // Consultar de la API en segundo plano para asegurar que está fresca
      SistemaSrv.ajustes(["whatsapp_plantilla_inicio_conversacion", "nombre_empresa"])
        .then((response) => {
          const rawAjuste = response?.data?.whatsapp_plantilla_inicio_conversacion;
          if (rawAjuste) {
            try {
              const parsed = typeof rawAjuste === "string" ? JSON.parse(rawAjuste) : rawAjuste;
              if (parsed) {
                this.plantilla = { ...this.plantilla, ...parsed };
              }
            } catch (e) { }
          }
          this.inicializarValoresVariables(chat, response?.data?.nombre_empresa);
        })
        .catch(() => {
          this.inicializarValoresVariables(chat);
        })
        .finally(() => {
          this.cargandoPlantilla = false;
        });
    },

    inicializarValoresVariables(chat, nombreEmpresaServidor) {
      const c = chat?.cliente || {};
      const empresa = nombreEmpresaServidor || (this.$store?.state?.todo?.nombre_empresa) || "ArgusBlack";

      const nombre = c.nombre || chat?.nombre || "";
      const apPaterno = c.apellido_paterno || "";
      const apMaterno = c.apellido_materno || "";
      const nombreCompleto = (c.nombre_completo || `${nombre} ${apPaterno} ${apMaterno}`).trim() || nombre || "Cliente";

      const mapaValores = {
        "{{nombre_empresa}}": empresa,
        "{{nombre_completo}}": nombreCompleto,
        "{{nombre}}": nombre || nombreCompleto,
        "{{apellido_paterno}}": apPaterno,
        "{{apellido_materno}}": apMaterno,
        "{{rfc}}": c.rfc || "-",
        "{{sexo}}": c.sexo || "-",
        "{{tipo_cliente}}": c.empresa ? "Empresa" : "Persona",
        "{{estado}}": c.activo ? "Activo" : "Inactivo",
        "{{calle}}": c.calle || "-",
        "{{numero_exterior}}": c.numero_exterior || "-",
        "{{numero_interior}}": c.numero_interior || "-",
        "{{colonia}}": c.colonia || "-",
        "{{delegacion}}": c.delegacion || c.municipio || "-",
        "{{codigo_postal}}": c.codigo_postal || "-",
        "{{estado_residencia}}": c.estado_residencia || "-",
        "{{pais}}": c.pais || "-",
        "{{correo_electronico}}": c.correo || "-"
      };

      const valores = {};
      this.variablesDetectadas.forEach((tag) => {
        valores[tag] = mapaValores[tag] !== undefined ? mapaValores[tag] : "";
      });

      this.valoresVariables = valores;
    },

    obtenerDescripcionVariable(tag) {
      for (const grupo of GRUPOS_VARIABLES) {
        const v = grupo.variables.find((item) => item.codigo === tag);
        if (v) return v.descripcion;
      }
      return tag.replace(/\{\{|\}\}/g, "");
    },

    enviar() {
      const idTelefono = this.chat?.id || this.chat?.id_telefono_cliente || this.chat?.id_telefono;
      if (!idTelefono) {
        if (typeof iu !== "undefined" && iu.msg) {
          iu.msg.error("No se encontró el identificador del teléfono del contacto.");
        }
        return;
      }

      this.enviando = true;

      // Convertir el mapa de variables {{key}} a clave limpia para el payload de la API
      const payloadApi = {};
      Object.keys(this.valoresVariables).forEach((tag) => {
        const cleanKey = tag.replace(/\{\{|\}\}/g, "").trim();
        payloadApi[cleanKey] = this.valoresVariables[tag];
      });

      WhatsappSrv.inicializarConversacion(idTelefono, payloadApi)
        .then((response) => {
          if (typeof iu !== "undefined" && iu.msg) {
            iu.msg.success("Plantilla de inicio de conversación enviada con éxito.");
          }
          this.cerrar();
          this.$emit("plantilla-enviada", {
            chat: this.chat,
            response: response?.data
          });
        })
        .catch((error) => {
          console.error("Error al enviar plantilla:", error);
          const errData = error.response ? error.response.data : {};
          const msg = errData.message || errData.error?.message || "Error al enviar la plantilla de inicio de conversación";
          if (typeof iu !== "undefined" && iu.msg) {
            iu.msg.error(msg);
          }
        })
        .finally(() => {
          this.enviando = false;
        });
    }
  }
};
</script>

<style scoped>
.wa-template-preview-box {
  background-color: #dcf8c6;
  border-color: #c4e9b1 !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
</style>

